import { faMinus, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, Badge, Card, Group, Text } from '@mantine/core';

export interface ChatHeaderProps {
  status?: 'idle' | 'active' | 'closed';
  messageCount?: number;
  isRestored?: boolean;
  onMinimize?: () => void;
  onClose?: () => void;
}

export function ChatHeader({
  status = 'idle',
  messageCount = 0,
  isRestored = false,
  onMinimize,
  onClose,
}: ChatHeaderProps) {
  const isConnected = status === 'active';

  return (
    <Card.Section withBorder p="md">
      <Group gap="xs" justify="space-between">
        <Group gap="xs">
          <Text fw={700}>Cowbell Support</Text>
          {isRestored && isConnected && (
            <Text size="xs" c="dimmed">
              (Session Restored)
            </Text>
          )}
        </Group>
        <Group gap="sm">
          {onMinimize && (
            <ActionIcon variant="light" radius="sm" onClick={onMinimize}>
              <FontAwesomeIcon icon={faMinus} size="sm" />
            </ActionIcon>
          )}
          {onClose && (
            <ActionIcon variant="light" radius="sm" onClick={onClose}>
              <FontAwesomeIcon icon={faXmark} size="sm" />
            </ActionIcon>
          )}
        </Group>
      </Group>

      <Group gap="xs">
        {isConnected ? (
          <>
            <Badge color="green" size="sm">
              Connected
            </Badge>
            {messageCount > 0 && (
              <Text size="sm" c="dimmed">
                {messageCount} messages
              </Text>
            )}
          </>
        ) : (
          <Badge color="red" size="sm">
            Disconnected
          </Badge>
        )}
      </Group>
    </Card.Section>
  );
}
